<template>
	<nk-wrapper v-if="context" spacing="md">
		<nk-meta v-if="context.datum_von && context.news">
			{{ getDateTimeString({dateFrom: context.datum_von}) }}
		</nk-meta>

		<nk-title v-if="context.titel" size="4xl" tag="h1">
			{{ context.titel }}
		</nk-title>

		<nk-image
			v-if="context.bild"
			class="sm:ml-4 sm:float-right w-full md:max-w-xs xl:max-w-sm"
			:copyright="context.bildcopyright"
			:src="context.bild"
			:alt="context.bildtext"
			:caption="context.bildtext"
			:lightbox="hasImageGallery ? 'bildergalerie' : true"
			:gallery="hasImageGallery ? context.bildergalerie_zuordnung.bilder : []"
		/>

		<nk-text v-if="context.einleitung" size="lg">
			{{ context.einleitung }}
		</nk-text>

		<div
			v-if="context.text"
			v-execute-script
			class="nk-cms-content nk-cms-content--detail"
			v-html="context.text"
		/>

		<div class="clear-both" />
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

export default {
	name: 'NkTemplateArtikel',
	mixins: [TemplatesDefault],

	computed: {
		hasImageGallery() {
			if (
				this.context.bildergalerie_zuordnung &&
				this.context.bildergalerie_zuordnung.bilder.length
			) {
				return true;
			}
			return false;
		},
	},

	methods: {
		getDateTimeString(object, dateFormat, timeFormat) {
			return this.$getDateTimeString(object, dateFormat, timeFormat);
		},
	},
};
</script>
